import React, { useCallback, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Form, FormGroup, Label, Button, Row, Col, Spinner } from "reactstrap";
import "./Support.css";
import Uploadform from "../../assets/images/upload_form.svg";
import { useDispatch, useSelector } from "react-redux";
import { createRequest, updateSupportPlatformRequest, updateSupportRequest } from "../../api/Applications";
import { handleFileUpload } from "../../utils/ImageToBase64";
import { categoryOptions, priorityOptions, requestTypeOptions, resolutionOptions, statusOptions } from "../patient/Constant";
import { failed, success } from "../../utils/Tostify";
import { getStaffs } from "../../api/User";
import { decryptData } from "../../utils/helper";
import { useNavigate } from "react-router";
import TextInput from "../../components/InputFields/TextInput";
import { useDropzone } from "react-dropzone";

const CreatePlatformRequest = ({ onCancel, getSupportRequestList, isEditMode, editData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userReducer.token);
  const user = useSelector((state) => state.userReducer.user);
  const [assignToList, setAssignToList] = useState([]);
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    requestType: Yup.string().required("Request Type is required"),
    category: Yup.string().required("Category is required")
    // assignedTo: Yup.string().required("Assigned To is required")
  });


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: editData?.title || "",
      description: editData?.description || "",
      docFile: null,
      requestType: editData?.requestType || null,
      category: editData?.category || null,
      priority: editData?.priority || null,
      assignedTo: editData?.assignedTo?._id || null,
      resolution: editData?.resolution || null,
      status: editData?.status || null,
      externalComment: isEditMode ? editData?.externalComment?.commentText || "" : "",
      internalComment: isEditMode ? editData?.internalComment?.commentText || "" : ""
    },
    validationSchema,
    onSubmit: async (values) => {
      let base64Files = [];

      for (let file of selectedFiles) {
        let base64pdfForm = await handleFileUpload(file);
        let fileExtension = file.type.split("/")[1];

        base64Files.push({
          base64String: base64pdfForm,
          extension: fileExtension,
          name: file.name
        });
      }

      let payload = {
        title: values.title,
        description: values.description,
        requestType: values.requestType,
        category: values.category || null,
        // ...(values.priority && { priority: values.priority }),
        priority: values.priority || null,
        assignedTo: values.assignedTo,
        // ...(values.resolution && { resolution: values.resolution }),
        resolution: values.resolution || null,
        ...(values.status && { status: values.status }),
        attachments: base64Files,
        externalComment: isEditMode
          ? values.externalComment
            ? { userId: editData?.externalComment?.userId || user._id, commentText: values.externalComment }
            : undefined
          : undefined,
        internalComment: isEditMode
        ? values.internalComment
          ? { userId: editData?.internalComment?.userId || user._id, commentText: values.internalComment }
          : undefined
        : undefined
      };

      try {
        setIsLoading(true);
        let res;

        if (isEditMode) {
          res = await updateSupportPlatformRequest({values: { ...payload }, dispatch, token, supportId: editData._id });
        } else {
          res = await createRequest({values: { ...payload, createdBy: user._id }, dispatch, token});
        }

        if (res.status === "SUCCESS") {
          success(res?.message);
          if (typeof getSupportRequestList === "function") {
          await getSupportRequestList();
          }
          formik.resetForm();
          setSelectedFiles([]);
          onCancel();
          navigate("/super-admin/support");
        } else {
          failed(res?.message || "Something went wrong");
        }
      } catch (error) {
        failed(error?.message || "Error occurred");
      } finally {
        setIsLoading(false);
      }
    }
  });

  const handleRemoveFile = (index) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(updatedFiles);
  };

   const getStaffList = async (page, limit, searchKey = "") => {
    let res;
    try {
            res = await getStaffs({ dispatch, token, page, limit, searchKey,dataLimit: "all" });
            const responseData = decryptData(res?.data);
            if (res?.status === "SUCCESS") {
              setAssignToList(responseData?.items.filter((item) =>
              item?.roleDetails?.some(role =>
                role.portalLayout === "Platform" && role.active
              )
            ).map((obj) => {
                return {
                  label: obj?.firstName + " " + obj?.lastName,
                  value: obj?._id,
                  role: obj?.defaultRole?.label
                };
              }));
            }
    } catch (error) {
      failed(res?.message);
    }
  };

  useEffect(() => {
    getStaffList();
  }, []);

  const handleDownloadDocument = async(url)=>{
    window.open(url);
  };

  const triggerFileInputDoc = (index) => {
    document.getElementById(`fileInputDoc-${index}`).click(); // Trigger file input
  };

  const handleFileSelect = async (event, formId, docId) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = async () => {
        const base64String = reader.result.split(",")[1]; // Get base64 data

        const payload = {
          attachments: [
            {
              _id: docId, // Existing attachment ID
              base64String,
              name: file.name
            }
          ]
        };

        try {
          const res = await updateSupportRequest({
            values: payload,
            dispatch,
            token,
            supportId: editData._id
          });

          if (res.success) {
            // "Attachment updated successfully"
          } else {
            // console.error("Failed to update attachment");
          }
        } catch (error) {
          // console.error("Error updating attachment:", error);
        }
      };
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    setSelectedFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: "image/jpeg,image/png,application/pdf",
    multiple: true
  });

  return (
    <div className="create_new_request m-0">
      <h6 className="block_name text-center">{isEditMode ? "Edit Platform Request" : "Create Platform Request"}</h6>
      <Form onSubmit={formik.handleSubmit}>
        <div className="first_block">
            <>
              <Row>
                <Col lg={12}>
                  <TextInput
                    keyField={"title"}
                    label="Title"
                    required={true}
                    formik={formik}
                    type="text"
                    value={formik.values.title}
                    onChange={(e) =>{
                      const inputValue = e.target.value.slice(0, 255); // Limit input to 500 chars
                      formik.setFieldValue("title", inputValue);
                    }}
                  />
                </Col>
                <Col lg={6}>
                 <TextInput
                    keyField="requestType"
                    label="Request Type"
                    options={requestTypeOptions}
                    type="select"
                    formik={formik}
                    required={true}
                    placeholder="Select Request Type"
                    value={formik.values.requestType}
                    onChange={(e) => {
                      formik.setFieldValue("requestType", e.target.value);
                    }}
                  />
                </Col>

                {isEditMode && (
                  <Col lg={6}>
                  <TextInput
                    keyField="resolution"
                    label="Resolution"
                    options={resolutionOptions}
                    type="select"
                    required={false}
                    formik={formik}
                    placeholder="Select Resolution"
                    value={formik.values.resolution}
                    onChange={(e) => {
                      formik.setFieldValue("resolution", e.target.value);
                    }}
                  />
                </Col>
                )}
                <Col lg={6}>
                  <TextInput
                    keyField="category"
                    label="Category"
                    options={categoryOptions}
                    type="select"
                    formik={formik}
                    required={true}
                    placeholder="Select Category"
                    value={formik.values.category}
                    onChange={(e) => {
                      formik.setFieldValue("category", e.target.value);
                    }}
                  />
                </Col>

                <Col lg={6}>
                  <TextInput
                    keyField="priority"
                    label="Priority"
                    options={priorityOptions}
                    type="select"
                    required={false}
                    formik={formik}
                    placeholder="Select Priority"
                    value={formik.values.priority}
                    onChange={(e) => {
                      formik.setFieldValue("priority", e.target.value);
                    }}
                  />
                </Col>
              <Col lg={6}>
                <TextInput
                  keyField="assignedTo"
                  label="Assign To"
                  options={assignToList}
                  type="select"
                  required={false}
                  formik={formik}
                  placeholder="Select Assignee"
                  value={formik.values.assignedTo || null}
                  onChange={(e) => {
                    formik.setFieldValue("assignedTo", e.target.value);
                  }}
                />
              </Col>
              {isEditMode && (
                  <Col lg={6}>
                  <TextInput
                    keyField="status"
                    label="Status"
                    options={statusOptions}
                    type="select"
                    required={false}
                    formik={formik}
                    placeholder="Select Status"
                    value={formik.values.status}
                    onChange={(e) => {
                      formik.setFieldValue("status", e.target.value);
                    }}
                  />
                </Col>
                )}
              <Col lg={12} className="location_block">
                  <p>Description <span style={{color : "red", marginLeft:"3px"}}>*</span></p>
                  <textarea
                    className="form-control"
                    rows="5"  // Controls the height of the box
                    maxLength="500"  // Enforces limit at the browser level
                    value={formik.values.description}
                    onChange={(e) => formik.setFieldValue("description", e.target.value)}
                  />
                  <p>{formik.values.description.length}/500</p> {/* Show character count */}
                  {formik.touched.description && formik.errors.description ? (
                      <span style={{ color: "red" }}>
                        {formik.errors.description}
                      </span>
                    ) : null}
                </Col>
                <div>
                {isEditMode && (
                    <div className="location_block">
                      <FormGroup>
                        <Label for="internalComment">Comment (Internal Use)</Label>
                      <textarea
                        className="form-control"
                        placeholder="Enter comments"
                        rows="2"  // Controls the height of the box
                        maxLength="500"  // Enforces limit at the browser level
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.internalComment}
                      />
                        {formik.touched.internalComment && formik.errors.internalComment && <div className="error">{formik.errors.internalComment}</div>}
                      </FormGroup>
                    </div>
                )}

                {isEditMode && (
                    <div className="location_block">
                      <FormGroup>
                        <Label for="externalComment"> Comment (External Use)</Label>
                        <textarea
                        className="form-control"
                        placeholder="Enter comments"
                        rows="2"  // Controls the height of the box
                        maxLength="500"  // Enforces limit at the browser level
                        onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.externalComment}
                      />
                        {formik.touched.externalComment && formik.errors.externalComment && <div className="error">{formik.errors.externalComment}</div>}
                      </FormGroup>
                    </div>
                )}
              </div>
               {/* Drag & Drop File Upload */}
               <Col lg={12}>
               <Label for="externalComment"> Attachment</Label>
              <div {...getRootProps()} className="upload-area text-center">
                <input {...getInputProps()} />
                <img src={Uploadform} alt="upload" />
                <p>Drag & drop files here, or click to browse</p>
                <button type="button" className="browse_blk">Browse</button>
              </div>
              </Col>
                </Row>
              <Row className="mt-3">
                <Col md={12}>{selectedFiles.length > 0 && (
                      <div className="uploaded-files mt-3">
                        {selectedFiles?.map((file, index) => (
                          <div key={index} className="file-item d-flex justify-content-between align-items-center">
                            <p style={{zIndex:"99"}}>{file.name}</p>
                            <button type="button" className="cancel-btn" onClick={() => handleRemoveFile(index)}>
                              <i className="fas fa-times" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}</Col>
              </Row>
            </>
        </div>


        {isEditMode && editData?.attachments?.length > 0 && (
        <>
          <div className="table_space table_listing_color">
            <div className="table-responsive">
              <table>
              <th></th>
              <th>Attachments</th>
                {editData?.attachments?.length > 0 && editData?.attachments.map((doc, index)=>(
                <tbody key={doc?._id}>
                  <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                    <td>{index + 1}</td>
                    <td>
                      {doc?.fileName}
                    </td>
                    <td className="p-0">
                      <span className="material-symbols-outlined" style={{cursor : "pointer"}} onClick={()=>doc?.filePath?.signedUrl ?  handleDownloadDocument(doc?.filePath?.signedUrl) : null} >download</span>
                    </td>
                    <td className="p-0 upload_blk">
                      <span
                        className="material-symbols-outlined"
                        style={{ cursor: 'pointer' }}
                        onClick={() => triggerFileInputDoc(index)} // Trigger file input when upload icon is clicked
                      >
                        upload
                      </span>
                      <input
                        type="file"
                        id={`fileInputDoc-${index}`}
                        style={{ display: 'none' }} // Hide the file input
                        onChange={(e) => handleFileSelect(e, "", doc._id,  "doc")} // Handle file selection
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={8} className="bg_light"></td>
                  </tr>
                </tbody>)) }
              </table>
            </div>
          </div>
        </>
        )}

        <div className="d-flex gap-3 justify-content-center mb-3">
          <Button type="button" className="save_btn cancel_btn" onClick={onCancel}>Cancel</Button>
          <Button type="submit" className="save_btn" disabled={isLoading || editData?.status === "Completed"}>
            {isLoading ? <Spinner size="sm" /> : "Save"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default CreatePlatformRequest;

